import {getAllTeammateModels} from '../team-utilities.js'

export function getItemChanges(action, combatantMap, currentCombatantStateChanges, combatantModels) {

    //Set up for modification
    let changes = {
        ...currentCombatantStateChanges
    };


    const casterModel = combatantModels[combatantMap.casterId];

    if (action.isItem) {

        //Find the person who owned this item and remove it from his/her inventory
        //If "use teammate items" is active (which is always, at the moment) you can use a teammate's item
        //That's why we don't assume it's the caster.
        if (action.actionMeta.instanceId) {

            const teamModels = getAllTeammateModels(casterModel, combatantModels);
            const itemOwnerModel = teamModels.filter(combModel => {
                return combModel.items.find(item => item.instanceId === action.actionMeta.instanceId);
            })[0];

            const updatedItemOwnerItems = itemOwnerModel.items.filter(item => {
                return item.instanceId !== action.actionMeta.instanceId
            });

            const existingOwnerChanges = changes.state[itemOwnerModel.id] || {};
            changes.state[itemOwnerModel.id] = {
                ...existingOwnerChanges,
                items: updatedItemOwnerItems.length ? updatedItemOwnerItems : false //use Boolean to protect from Firebase eating
            };


            //Check if this ITEM was bugged. If so, set a flag (similar to Fail) that will bypass state operations.
            if (action.actionMeta.isBugged) {
                changes["wasBugged"] = true;
            }


        } else {
            console.warn('no instanceId found in item submission', action)
        }

    }

    return changes;
}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/description/items.js